import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Toast from 'react-bootstrap/Toast';
import { ModalBody } from 'react-bootstrap';
import { apiValidation, copyToClipboardHybrid, get, isWebView } from '../../Utilities';
import { getCurrentBranding } from '../../redux/reducers/branding.reducer';
import '../Dashboard/Dashboard.scss';
import './DummyDashboard.scss';
import share from '../../assets/images/dummyDashboard/share.svg';
import '../Common/ScrollableCards/ScrollableCards.scss';
import { getClientId, getLanguageObject } from '../../redux/reducers/clientUserId.reducer';
import { getCurrentDashboardData } from '../../redux/reducers/dashboard.reducer';
import EmblaPeek from './EmblaCarousel';
import PageHeaderNew from '../Common/PageHeader/PageHeaderNew';
import Footer from './Footer';
import BackdropLoader from '../Common/BackdropLoader/BackdropLoader';
import AboutUsDummy from './AboutUsDummy';
import CourseCardNew from '../Common/CourseCardNew/CourseCardNew';
import { ArrowUpward, SearchSharp } from '@mui/icons-material';
import AppointmentCardNew from '../Common/CourseCardNew/AppointmentCardNew';
import FAQ from '../Common/PrivacyPolicy/FAQ';

const aboutDummyText = `Welcome to our online learning platform, where knowledge meets convenience. We offer a wide range of courses and services designed to help learners gain new skills, grow, and achieve their goals through flexible, engaging, and accessible learning experiences.`;

const DummyDashboard = (props) => {
  const {
    clientId,
    currentbranding: { branding },
    changeComponent,
    dashboardData,
    languageObject = {},
    history,
  } = props;

  const [dummyData, setDummyData] = useState({});
  const [notices, setNotices] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAllCourses, setShowAllCourses] = useState(false);
  const [recentCourses, setRecentCourses] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showModal, setShow] = useState(false);
  const [categoryView, setCategoryView] = useState('standard');

    const [isFaqAdded, setIsFaqAdded] = useState(false);
  
    useEffect(() => {
      get({ client_id: clientId }, '/areFaqsAdded').then((res) => {
        if (res && res.success) {
          setIsFaqAdded(res.result);
        }
      });
    }, []);

  const handleClose = () => setShow(false);

  useEffect(() => {
    if (isWebView && typeof window.Android.setIsRedirectExternal !== 'undefined') {
      window.Android.setIsRedirectExternal('true');
    }
    if (isWebView && typeof window.Android.disableSwipeRefresh !== 'undefined') {
      window.Android.disableSwipeRefresh();
    }
    if (!clientId) {
      history.replace('/preload');
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const [loginRes, recentRes, categoriesRes, appointmentRes] = await Promise.all([
          get({ client_id: clientId, is_skip: true, is_new: true }, '/getLoginPageInformation'),
          get({ client_id: clientId, is_skip: true }, '/getRecentCourses'),
          get({ client_id: clientId }, '/getCourseCategoriesOfCoaching'),
          get({ client_id: clientId }, '/getAllAppointmentsOfClientHomepage'),
        ]);

        if (loginRes?.success) {
          const result = apiValidation(loginRes);
          if (Number(result.credis_available) < 1) {
            const path = '/userservice-unavailable';
            history.replace({ pathname: path });
          } else {
            setDummyData(result);
            setNotices(result.notice);
          }
        }

        if (recentRes?.success) {
          const result = apiValidation(recentRes);
          setRecentCourses(result.assigned_courses);
        }

        if (categoriesRes?.success) {
          const result = apiValidation(categoriesRes);
          setCategories(result);
          setCategoryView(categoriesRes.isTileView ? 'tiles' : 'standard');
        }

        if (appointmentRes?.success) {
          const result = apiValidation(appointmentRes);
          setAppointments(result);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [clientId]);

  // Reset showAllCourses when category changes
  useEffect(() => {
    setShowAllCourses(false);
  }, [selectedCategory]);

  const shareThis = () => {
    if (navigator.share) {
      navigator
        .share({
          title: `Come Join Us`,
          text: `Hey, ${dummyData.client_name} is a fast, simple and fun app that I use for learning and growing everyday`,
          url: window.location.href,
        })
        .then(() => console.log('Thanks for sharing!'))
        .catch(console.error);
    } else {
      if (isWebView && typeof window.Android.share !== 'undefined') {
        Android.share(
          dashboardData.client_name,
          dashboardData.app_share_message ? dashboardData.app_share_message : dashboardData.appLink,
        );
      } else {
        setShowToast(true);
        copyToClipboardHybrid(
          dashboardData.app_share_message ? dashboardData.app_share_message : dashboardData.appLink,
        );
      }
    }
  };

  const goToBuyCourse = (id) => {
    const { push } = history;
    push({ pathname: `/courses/buyCourse/${window.btoa(clientId)}/${window.btoa(id)}` });
  };

  // ✅ Filter first, then slice
  const filteredCourses = recentCourses.filter((ele) =>
    selectedCategory === 'all' ? true : ele.category_names.includes(selectedCategory),
  );

  const displayedCourses = showAllCourses ? filteredCourses : filteredCourses.slice(0, 8);

  const hasMoreCourses = filteredCourses.length > 8;

  const scrollToAbout = () => {
    const aboutSection = document.querySelector('.AboutUsDummy');
    if (aboutSection) {
      const yOffset = -120;
      const y = aboutSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const scrollToCourses = () => {
    const coursesSection = document.getElementById('courses-section');
    if (coursesSection) {
      const yOffset = -95;
      const y = coursesSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const scrollToFooter = () =>
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      {loading ? (
        <div className='w-100 text-center mt-5'>
          <BackdropLoader isLoading={loading} />
        </div>
      ) : (
        Object.keys(dummyData).length > 0 && (
          <div className='text-center' style={{ background: 'var(--superlight-blue)' }}>
            <PageHeaderNew
              history={history}
              updateComponent={changeComponent}
              isLogout
              showCourses={recentCourses.length > 0}
              scrollToAbout={scrollToAbout}
              scrollToCourses={scrollToCourses}
              isClientColor={false}
              scrollToFooter={scrollToFooter}
              scrollToTop={scrollToTop}
            />

            <div className='my-1 mx-0 mt-5 pt-3'>
              <EmblaPeek
                slides={dummyData?.posters
                  ?.filter((ele) => ele.file_type === 'image')
                  ?.map((ele) => (
                    <div className='Dummy__caraouselImageHero'>
                      <img className='Dummy__caraouselImageHeroImage' src={ele.file_link} />
                    </div>
                  ))}
              />
            </div>

            <div className='AboutUsDummy'>
              <AboutUsDummy
                aboutUs={dummyData.about_us || aboutDummyText}
                tagline={branding.client_tagline}
              />
            </div>

            {recentCourses.length > 0 && dummyData?.feature?.courses?.status === 'active' && (
              <>
                <h1
                  id='courses-section'
                  className='pb-0 pt-5 mt-2 text-center font-bold dashboardTitleh1'
                >
                  Our Courses
                </h1>

                {categories.length > 0 &&
                  (categoryView === 'standard' ? (
                    <div className='d-flex w-90 mx-auto align-items-center gap-2 my-4 Dummy__categoryContainer'>
                      <div
                        onClick={() => setSelectedCategory('all')}
                        role='button'
                        className={`Dummy__categoryPill py-2 font ${
                          selectedCategory === 'all' ? 'Dummy__activePill' : ''
                        }`}
                      >
                        All Courses
                      </div>
                      {categories.map((cat) => (
                        <div
                          key={cat}
                          onClick={() => setSelectedCategory(cat)}
                          role='button'
                          className={`Dummy__categoryPill py-2 font ${
                            selectedCategory === cat ? 'Dummy__activePill' : ''
                          }`}
                        >
                          {cat}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className='TilesView__grid my-4 mx-auto'>
                      {[...categories.map((cat) => ({ label: cat, value: cat }))].map(
                        ({ label, value }, index) => {
                          const isActive =
                            window.screen.width < 768
                              ? [0, 3, 4, 7, 8, 11, 12, 15, 16].includes(index)
                              : index % 2 === 0;
                          return (
                            <div
                              key={value}
                              className='TilesView__cell'
                              onClick={() =>
                                history.push({
                                  pathname: '/explore/allcourses',
                                  search: `?category=${label}`,
                                })
                              }
                              role='button'
                            >
                              <div
                                className={`TilesView__card ${
                                  isActive ? 'TilesView__card--active' : ''
                                }`}
                              >
                                <div className='TilesView__cardTitle font'>{label}</div>
                                <div className='TilesView__cardArrow'>
                                  <span className='TilesView__arrowCircle'>&#8250;</span>
                                </div>
                              </div>
                            </div>
                          );
                        },
                      )}
                    </div>
                  ))}
                {categoryView === 'standard' && (
                  <div
                    style={filteredCourses.length === 0 ? { minHeight: '300px' } : {}}
                    className='py-2 py-md-3 px-0 px-sm-5 position-relative course-grid'
                  >
                    {filteredCourses.length === 0 ? (
                      <div className='text-center position-absolute w-100 py-5'>
                        <div className='text-center fs-5'>
                          <SearchSharp style={{ fontSize: '120px', color: '#ccc' }} />
                          <p
                            style={{ fontSize: '32px', color: 'var(--lighter-blue)' }}
                            className='font-bold mb-0'
                          >
                            No results found
                          </p>
                          <p className='font text-muted'>Please try a different category</p>
                        </div>
                      </div>
                    ) : (
                      displayedCourses.map((ele, index) => (
                        <CourseCardNew
                          languageObject={languageObject}
                          onClick={() => goToBuyCourse(ele.course_id)}
                          key={index}
                          item={ele}
                        />
                      ))
                    )}
                  </div>
                )}

                {hasMoreCourses && !showAllCourses && (
                  <div className='text-center pb-3'>
                    <Button
                      variant='customPrimary'
                      className='mt-4'
                      onClick={() => history.push('/explore/allcourses')}
                      style={{
                        padding: '12px 40px',
                        fontSize: '1rem',
                        fontWeight: '600',
                        borderRadius: '8px',
                      }}
                    >
                      Show All Courses ({filteredCourses.length})
                    </Button>
                  </div>
                )}
              </>
            )}

            {appointments.length > 0 && dummyData?.feature?.courses?.status === 'active' && (
              <div>
                <h1
                  id='courses-section'
                  className='pb-0 pt-5 mt-2 mb-4 text-center font-bold dashboardTitleh1'
                >
                  Appointments
                </h1>

                <div
                  style={appointments.length === 0 ? { minHeight: '300px' } : {}}
                  className='py-2 py-md-3 px-3 px-sm-5 position-relative appointments-grid1'
                >
                  {appointments.map((ele, index) => (
                    <AppointmentCardNew
                      onClick={() => history.push(ele.sharePathname)}
                      key={index}
                      item={ele}
                    />
                  ))}
                </div>
              </div>
            )}

            <div className='my-3 px-3 px-sm-5 mx-auto mt-5 largeScreenPadding'>
              <Row className='mx-0 justify-content-center align-items-center text-center text-md-start mt-2'>
                <Col xs={12} md={6} className='p-3 p-md-0 text-center text-md-left'>
                  <p className='Dummy__joinDetailsDummy font-bold mb-2'>
                    <span style={{ color: 'var(--primary-blue)' }}>Enjoying</span> the application?
                  </p>
                  <h6 className='Dummy__connectDummy font-bold mb-4 mb-md-5'>
                    Share app with <span style={{ color: 'var(--primary-blue)' }}>friends</span>
                  </h6>
                  <Button
                    variant='customPrimary'
                    style={{ borderRadius: '5px' }}
                    className='mb-3 fillAdmissionFormButton font'
                    onClick={shareThis}
                  >
                    Share
                  </Button>
                </Col>

                <Col
                  xs={12}
                  md={5}
                  className='p-3 d-flex justify-content-center justify-content-md-end'
                >
                  <img
                    src={share}
                    alt='form'
                    className='shareImageDummy'
                    style={{
                      width: '225px',
                      height: 'auto',
                    }}
                  />
                </Col>
              </Row>
            </div>

            <div className='px-3 mb-4 px-sm-5'>
              {isFaqAdded && <h1
                  id='courses-section'
                  className='pb-0 pt-4 mt-2 mb-4 text-center font-bold dashboardTitleh1'
                >
                  FAQs
                </h1>}
              <FAQ history={history} noHeader noHeading />
            </div>
            <Footer branding={branding} clientId={clientId} />

            <Toast
              style={{
                position: 'fixed',
                bottom: '20px',
                right: '15%',
                zIndex: '999',
              }}
              onClose={() => setShowToast(false)}
              show={showToast}
              delay={3000}
              autohide
            >
              <Toast.Header>
                <strong className='mr-auto'>Copied!</strong>
                <small>Just Now</small>
              </Toast.Header>
              <Toast.Body>The link has been copied to your clipboard!</Toast.Body>
            </Toast>

            <Modal centered show={showModal} onHide={handleClose}>
              <ModalBody className='d-flex align-items-center justify-content-center'>
                <h4 style={{ textAlign: 'center', fontFamily: 'Montserrat, sans-serif' }}>
                  This button is for preview only.
                </h4>
              </ModalBody>
            </Modal>
          </div>
        )
      )}
      <div className='Dummy__gototop' role='button' onClick={scrollToTop}>
        <ArrowUpward style={{ color: 'var(--primary-blur)' }} />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  currentbranding: getCurrentBranding(state),
  clientId: getClientId(state),
  dashboardData: getCurrentDashboardData(state),
  languageObject: getLanguageObject(state),
});

export default connect(mapStateToProps, null)(DummyDashboard);
